import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  fetchWorkflowList,
  taskClearFormData,
} from 'reducers/jobTasksAdmin/reducer'
import TaskList from './TaskList'
import TaskItem from './TaskItem'

function Tasks(props) {
  const {
    match: {
      params: { id },
    },
    taskClearFormData,
  } = props

  useEffect(
    () => () => {
      taskClearFormData()
    },
    [],
  )

  return (
    <div className="content task-form-content">
      {id ? <TaskItem {...props} /> : <TaskList {...props} />}
    </div>
  )
}

Tasks.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  taskClearFormData: PropTypes.func.isRequired,
}

export default connect(null, {
  fetchWorkflowList,
  taskClearFormData,
})(withRouter(Tasks))
